function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M602.9 450.614L82.9 435.714C58.7 435.014 38.8 416.514 36.4 392.414L11.3 144.414C8.49998 116.314 30.3 91.8138 58.5 91.4138L637.3 83.4138C666.5 83.0138 689.4 108.514 685.8 137.514L652.1 408.514C649 433.114 627.7 451.414 602.9 450.614Z",
  fill: "#D2E0F6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M602.9 450.614L82.9 435.714C58.7 435.014 38.8 416.514 36.4 392.414L11.3 144.414C8.49998 116.314 30.3 91.8138 58.5 91.4138L637.3 83.4138C666.5 83.0138 689.4 108.514 685.8 137.514L652.1 408.514C649 433.114 627.7 451.414 602.9 450.614Z",
  fill: "#EAF9F3"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_301_3057)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M178.5 495.714H-237C-245.3 495.714 -252 489.014 -252 480.714V245.014C-252 236.714 -245.3 230.014 -237 230.014H178.5C186.8 230.014 193.5 236.714 193.5 245.014V480.614C193.5 488.914 186.8 495.714 178.5 495.714Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.6 479.814H308.5C300.2 479.814 293.5 473.114 293.5 464.814V120.514C293.5 112.214 300.2 105.514 308.5 105.514H727.6C735.9 105.514 742.6 112.214 742.6 120.514V464.814C742.6 473.114 735.9 479.814 727.6 479.814Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.7 230.014H43.4C41.2 230.014 39.4 228.414 39.1 226.214L37.5 211.814C37.2 209.314 39.2 207.014 41.8 207.014H65.3C67.9 207.014 69.8 209.214 69.6 211.814L68 226.214C67.7 228.414 65.9 230.014 63.7 230.014Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.1 207.114C51.1 207.114 43.1 206.314 41.5 195.514C41.5 195.514 48.7 197.614 51 202.714C51 202.714 52 191.314 57.4 190.214C57.4 190.214 59.8 198.714 56 202.914C56 202.914 58.9 198.114 66.3 198.214C66.3 198.214 64.4 205.014 57.1 207.014",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.4 279.714H85.2C82.9 279.714 81 277.814 81 275.514V248.114C81 245.814 82.9 243.914 85.2 243.914H175.4C177.7 243.914 179.6 245.814 179.6 248.114V275.514C179.6 277.814 177.7 279.714 175.4 279.714Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.6 253.614H119.8C119 253.614 118.3 252.914 118.3 252.114C118.3 251.314 119 250.614 119.8 250.614H140.6C141.4 250.614 142.1 251.314 142.1 252.114C142.1 252.914 141.5 253.614 140.6 253.614Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.4 325.514H85.2C82.9 325.514 81 323.614 81 321.314V293.914C81 291.614 82.9 289.714 85.2 289.714H175.4C177.7 289.714 179.6 291.614 179.6 293.914V321.314C179.6 323.614 177.7 325.514 175.4 325.514Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.6 299.414H119.8C119 299.414 118.3 298.714 118.3 297.914C118.3 297.114 119 296.414 119.8 296.414H140.6C141.4 296.414 142.1 297.114 142.1 297.914C142.1 298.714 141.5 299.414 140.6 299.414Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M638.5 357.914H548.3C546 357.914 544.1 356.014 544.1 353.714V326.314C544.1 324.014 546 322.114 548.3 322.114H638.5C640.8 322.114 642.7 324.014 642.7 326.314V353.714C642.8 356.014 640.9 357.914 638.5 357.914Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M603.8 331.714H583C582.2 331.714 581.5 331.014 581.5 330.214C581.5 329.414 582.2 328.714 583 328.714H603.8C604.6 328.714 605.3 329.414 605.3 330.214C605.3 331.114 604.6 331.714 603.8 331.714Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M522.7 357.914H432.5C430.2 357.914 428.3 356.014 428.3 353.714V326.314C428.3 324.014 430.2 322.114 432.5 322.114H522.7C525 322.114 526.9 324.014 526.9 326.314V353.714C527 356.014 525.1 357.914 522.7 357.914Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M488 331.714H467.2C466.4 331.714 465.7 331.014 465.7 330.214C465.7 329.414 466.4 328.714 467.2 328.714H488C488.8 328.714 489.5 329.414 489.5 330.214C489.5 331.114 488.8 331.714 488 331.714Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.4 279.714H-29.8C-32.1 279.714 -34 277.814 -34 275.514V248.114C-34 245.814 -32.1 243.914 -29.8 243.914H60.4C62.7 243.914 64.6 245.814 64.6 248.114V275.514C64.6 277.814 62.7 279.714 60.4 279.714Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.6 253.614H4.79999C3.99999 253.614 3.29999 252.914 3.29999 252.114C3.29999 251.314 3.99999 250.614 4.79999 250.614H25.6C26.4 250.614 27.1 251.314 27.1 252.114C27.1 252.914 26.5 253.614 25.6 253.614Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.4 325.514H-29.8C-32.1 325.514 -34 323.614 -34 321.314V293.914C-34 291.614 -32.1 289.714 -29.8 289.714H60.4C62.7 289.714 64.6 291.614 64.6 293.914V321.314C64.6 323.614 62.7 325.514 60.4 325.514Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.6 299.414H4.79999C3.99999 299.414 3.29999 298.714 3.29999 297.914C3.29999 297.114 3.99999 296.414 4.79999 296.414H25.6C26.4 296.414 27.1 297.114 27.1 297.914C27.1 298.714 26.5 299.414 25.6 299.414Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.9 210.414H314.9C312.4 210.414 310.3 208.314 310.3 205.814V126.114C310.3 123.614 312.4 121.514 314.9 121.514H769.9C772.4 121.514 774.5 123.614 774.5 126.114V205.814C774.5 208.314 772.4 210.414 769.9 210.414Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.9 309.314H314.9C312.4 309.314 310.3 307.214 310.3 304.714V225.014C310.3 222.514 312.4 220.414 314.9 220.414H769.9C772.4 220.414 774.5 222.514 774.5 225.014V304.714C774.5 307.214 772.4 309.314 769.9 309.314Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M350.8 160.114H340.9V210.414H350.8V160.114Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M361 173.814H350.7V210.414H361V173.814Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M649.2 258.914H639.3V309.214H649.2V258.914Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M659.4 272.614H649.1V309.214H659.4V272.614Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M629 258.914H619.1V309.214H629V258.914Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M619.233 260.776L609.792 257.795L594.647 305.761L604.088 308.742L619.233 260.776Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M639.3 272.614H629V309.214H639.3V272.614Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M515.6 160.114H505.7V210.414H515.6V160.114Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525.9 173.814H515.6V210.414H525.9V173.814Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M417.9 160.114H408V210.414H417.9V160.114Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M408.154 161.895L398.713 158.914L383.568 206.88L393.009 209.861L408.154 161.895Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M428.1 173.814H417.8V210.414H428.1V173.814Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M649 166.614L650.1 151.714C650.2 150.714 649.4 149.914 648.4 149.914H644.1H639.8C638.8 149.914 638.1 150.714 638.1 151.714L639.2 166.614C639.2 166.614 630.2 172.414 630.3 177.214C630.4 180.914 632.6 198.614 633.6 206.414C633.9 208.614 635.7 210.214 637.9 210.214H644.1H650.3C652.5 210.214 654.3 208.614 654.6 206.414C655.6 198.614 657.8 180.914 657.9 177.214C658 172.414 649 166.614 649 166.614Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M609.2 166.614L610.3 151.714C610.4 150.714 609.6 149.914 608.6 149.914H604.3H600C599 149.914 598.3 150.714 598.3 151.714L599.4 166.614C599.4 166.614 590.4 172.414 590.5 177.214C590.6 180.914 592.8 198.614 593.8 206.414C594.1 208.614 595.9 210.214 598.1 210.214H604.3H610.5C612.7 210.214 614.5 208.614 614.8 206.414C615.8 198.614 618 180.914 618.1 177.214C618.2 172.414 609.2 166.614 609.2 166.614Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.89999 403.714H965.7",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M110.1 317.614L97.4 495.214C97.3 496.714 98.5 498.014 100 498.014C101.4 498.014 102.5 497.014 102.6 495.614L117.9 317.614H110.1Z",
  fill: "#77A1E3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M624.2 317.614L636.9 495.214C637 496.714 635.8 498.014 634.3 498.014C632.9 498.014 631.8 497.014 631.7 495.614L616.4 317.614H624.2Z",
  fill: "#77A1E3"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M221.3 97.8138C221.3 97.8138 230.2 115.914 236.6 132.214C243 148.514 244.1 163.614 237.9 166.814C229.2 171.314 219.5 171.614 208.3 150.414C197.1 129.214 205.5 81.3138 221.3 97.8138Z",
  fill: "#22272E"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M173.4 428.414C173.5 429.614 169.9 449.914 170.1 451.414C170.4 452.914 154.8 456.814 147.3 450.114C147.3 450.114 148.4 423.614 148.4 419.614C148.4 415.714 172.7 417.214 173.4 428.414Z",
  fill: "#F7D4D9"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M170.4 447.814C170.4 447.814 172.1 455.314 174.6 459.914C177.1 464.514 190.9 477.414 189.4 481.814C187.9 486.214 175.2 486.614 165.4 486.214C155.6 485.814 151.2 482.414 147.3 475.414C143.3 468.414 146 463.714 146.5 450.114C146.5 450.114 146.8 447.814 147.4 447.414C147.4 447.414 149.4 450.914 151.7 451.214C154 451.414 156.3 445.914 161.9 445.314C167.5 444.814 168.2 450.314 168.8 450.314C169.5 450.314 170.2 449.414 170.4 447.814Z",
  fill: "#F6AE2D"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M179.5 469.314C179.5 469.314 172.5 466.314 159.5 471.214",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M177 463.814C177 463.814 170 460.814 157 465.714",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M223.4 424.914C223.5 426.114 219.9 446.414 220.1 447.914C220.4 449.414 204.8 453.314 197.3 446.614C197.3 446.614 198.4 420.114 198.4 416.114C198.4 412.214 222.8 413.714 223.4 424.914Z",
  fill: "#F7D4D9"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M220.5 444.214C220.5 444.214 222.2 451.714 224.7 456.314C227.2 460.914 241 473.814 239.5 478.214C238 482.614 225.3 483.014 215.5 482.614C205.7 482.214 201.3 478.814 197.4 471.814C193.4 464.814 196.1 460.114 196.6 446.514C196.6 446.514 196.9 444.214 197.5 443.814C197.5 443.814 199.5 447.314 201.8 447.614C204.1 447.814 206.4 442.314 212 441.714C217.6 441.214 218.3 446.714 218.9 446.714C219.6 446.814 220.3 445.914 220.5 444.214Z",
  fill: "#F6AE2D"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M229.5 465.814C229.5 465.814 222.5 462.814 209.5 467.714",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M227.1 460.314C227.1 460.314 220.1 457.314 207.1 462.214",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M128.7 209.114C128.7 209.114 125.7 226.614 134.3 267.714C136.9 280.214 139 296.514 140.5 313.614C144 352.614 141 392.414 139.2 408.114C136.6 430.614 148.1 434.914 160.5 435.914C172.9 436.914 177.5 431.214 178.1 424.914C178.7 418.614 186.1 334.614 188.9 315.614C191.8 296.614 192 270.614 191.1 266.814C190.2 263.014 201 263.814 196.5 216.814C192.1 169.614 132.3 196.614 128.7 209.114Z",
  fill: "#1D62D1"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M214.8 211.414C214.8 211.414 229.8 275.614 231.6 295.614C233.4 315.614 229.7 413.714 229.8 419.614C230 425.514 224.5 430.814 211.1 431.114C197.7 431.414 192.3 422.514 192.4 417.714C192.7 401.714 192.9 338.014 191.9 328.214C190.9 318.414 176.3 270.214 173.4 265.614C170.5 260.914 164.1 226.414 176.7 220.414C189.3 214.414 209.1 205.414 214.8 211.414Z",
  fill: "#1D62D1"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M195.9 83.3138C195.9 83.3138 170.3 82.4138 158.4 80.8138C146.5 79.2138 124.3 79.1138 115.5 97.0138C106.7 114.914 134 123.714 133.3 136.414C132.7 149.014 130.8 170.614 130.8 170.614C130.8 170.614 128.3 194.714 125.5 203.814C122.7 212.914 128 217.514 130.5 218.314C133 219.114 159 224.414 178.7 223.314C198.4 222.214 214.5 217.714 215.9 213.314C217.4 208.914 215 196.014 215.9 182.514C216.8 169.014 219.4 145.414 219.4 136.414C219.4 127.414 223.8 104.614 219.4 95.2138C215 85.8138 204.4 83.6138 195.9 83.3138Z",
  fill: "#F6AE2D"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M162.3 72.7138C162.3 72.7138 158.2 73.3138 156.8 76.0138C155.9 77.7138 154.8 80.8138 154.9 84.0138C155 87.2138 159.8 96.0139 173.7 97.6139C187.7 99.2139 192.6 92.4138 193.2 89.8138C193.8 87.2138 192.8 80.2138 191.8 79.0138C190.9 77.7138 189.4 76.4138 184.4 75.8138C179.5 75.0138 163.9 72.1138 162.3 72.7138Z",
  fill: "#22272E"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M182.4 133.514C182.4 133.514 186.5 129.214 188.6 126.014C190.7 122.814 193.5 119.314 195.8 118.014C198.1 116.614 202.9 115.814 204.2 115.114C205.6 114.414 207 116.914 204.2 119.214C201.4 121.514 202.6 128.214 198.7 131.814C194.7 135.414 183.8 137.614 182.4 133.514Z",
  fill: "#B28D93"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M211.5 74.3138L262 71.0138C263.5 70.9138 264.7 72.2138 264.5 73.7138L252.1 149.914C251.8 151.614 250.5 152.914 248.8 153.114L200.5 159.714C199 159.914 197.7 158.614 197.8 157.114L208 77.7138C208.1 75.8138 209.6 74.4138 211.5 74.3138Z",
  fill: "#22272E"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M247.2 74.5138L228.1 75.5138C227.4 75.5138 226.8 74.9138 226.9 74.2138L227.2 72.2138C227.3 71.4138 228 70.8138 228.7 70.8138L247.8 69.8138C248.5 69.8138 249.1 70.4138 249 71.1138L248.7 73.1138C248.6 73.9138 247.9 74.4138 247.2 74.5138Z",
  fill: "#F6AE2D"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M135.8 151.714C135.8 151.714 142.1 126.414 143.7 116.714C145.3 107.014 139.2 96.2138 129.8 93.8138C118.8 91.1138 115.4 96.9138 115.4 96.9138C115.4 96.9138 111 104.614 106.6 128.814C102.2 153.014 99.7 175.514 115.4 181.014C131.1 186.514 163.3 168.614 173.6 160.914C183.9 153.314 187.7 150.014 189.7 149.514C191.7 149.014 199.6 151.114 203.8 146.414C208 141.714 211.6 138.014 212 138.014C212.4 138.014 222.4 139.514 224.1 138.214C226 136.714 223.2 135.214 221.2 134.914C219.3 134.614 213.5 132.714 213.5 132.714C213.5 132.714 218 131.314 221.2 130.114C224.4 128.814 227.7 128.214 227.5 126.514C227.3 124.714 225.3 125.014 223.3 124.914C221.3 124.814 218.6 125.414 218.6 125.414C218.6 125.414 224.1 123.914 225.5 122.314C227 120.614 225.7 119.314 222.8 119.614C220.5 119.814 217.3 120.614 217.3 120.614C217.3 120.614 222.9 120.114 222.5 117.614C222.2 115.914 217.2 116.814 213.9 117.214C210.6 117.614 206.4 118.414 202.8 119.314C200.4 119.914 198.2 120.614 196.7 121.314C193.2 123.014 184.4 131.414 183 133.114C181.6 134.814 164 137.614 149.6 140.814C135.2 143.914 126.8 146.614 122.4 150.714L135.8 151.714Z",
  fill: "#B28D93"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M214.1 117.114C210.8 117.514 206.6 118.314 203 119.214C200.6 119.814 198.4 120.514 196.9 121.214",
  stroke: "#896068",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M186 151.714C183.5 153.514 179.7 156.514 173.7 160.914C163.4 168.514 131.2 186.414 115.5 181.014C99.9 175.514 102.4 153.014 106.7 128.814C111.1 104.614 115.5 96.9138 115.5 96.9138C115.5 96.9138 118.9 91.1138 129.9 93.8138C139.2 96.1138 145.4 106.914 143.8 116.714C142.8 122.814 139.9 135.214 137.9 143.514C141.4 142.514 145.4 141.614 150 140.614C160.2 138.414 172.1 136.314 178.6 134.714C178.5 135.014 177.2 140.414 179.7 145.514C182 150.714 186 151.714 186 151.714Z",
  fill: "#22272E"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M105.7 171.514C105.7 171.514 105.5 166.114 112.1 166.814C118.6 167.514 135.8 173.714 130.9 181.014",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M170.6 136.514C170.6 136.514 169.1 142.314 171.8 148.214C174.5 154.014 179.4 156.814 179.4 156.814",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M161.5 57.0138C161.5 57.0138 161.2 69.8138 160.4 77.8138C159.6 85.8138 174.5 89.1138 181.7 87.7138C188.9 86.3138 190 84.1138 190 84.1138C190 84.1138 189.4 73.3138 190 69.4138C190.6 65.5138 161.6 52.8138 161.5 57.0138Z",
  fill: "#B28D93"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M189.8 81.2139C189.7 79.6139 189.7 77.5138 189.7 75.4138C183.6 75.7138 178.2 70.1139 173.8 65.5139C172.6 75.1139 180.9 81.3139 189.8 81.2139Z",
  fill: "#896068"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M201.6 40.0138C201.6 40.0138 206.6 37.4138 208.1 29.2138C209.6 20.9138 207.8 8.81384 202.2 7.41384C196.5 5.91384 200.5 23.2138 196.7 26.4138C192.9 29.5138 201.6 35.5138 201.6 40.0138Z",
  fill: "#22272E"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M201.4 25.9138C201.4 25.9138 203.1 32.8138 202.5 42.9138C201.9 53.1138 203.9 70.3138 192.8 75.3138C181.7 80.3138 167 75.1138 161 58.7138C155 42.3138 154.9 26.0138 164.1 19.0138C173.4 11.9138 198.1 12.9138 201.4 25.9138Z",
  fill: "#B28D93"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M162.2 45.6138C162.2 45.6138 165.6 44.5138 165.7 38.4138C165.7 32.2138 169 27.1138 175.6 28.9138C182.2 30.7138 191.4 35.8138 196.8 35.7138C203.2 35.5138 205.2 28.6138 205.7 20.1138C206.2 11.5138 203.4 6.31383 200.1 7.21383C196.8 8.11383 194 10.9138 189.9 5.71383C184.3 -1.28617 179.3 -1.08617 175.3 2.21383C168.3 8.11383 169.9 11.2138 163.5 8.71383C159.8 7.21383 157.2 7.61384 155.4 14.5138C153.6 21.4138 154.3 23.3138 150 22.7138C145.6 22.1138 148.4 44.9138 155.4 50.0138C155.5 50.0138 160.9 45.1138 162.2 45.6138Z",
  fill: "#22272E"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M196.6 47.3138C197 48.4138 197.2 49.5138 197.5 50.5138C197.8 51.5138 198.1 52.6138 198.4 53.4138C198.6 53.9138 198.9 54.6138 198.9 55.3138C198.9 56.0138 198.8 56.8138 198.3 57.3138C197.4 58.4138 196.1 58.7138 194.9 58.6138C195.9 58.0138 196.8 57.3138 197.1 56.6138C197.4 55.9138 197.2 55.1138 196.7 54.2138C196.2 53.0138 196 51.9138 196 50.7138C196.1 49.5138 196.3 48.4138 196.6 47.3138Z",
  fill: "#22272E"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M186.9 38.6139C187.8 38.7139 188.5 37.9139 188.2 37.0139C187.9 36.1139 187.7 35.3139 186.7 35.1139C184.6 34.6139 180.1 35.0139 177.4 37.0139C174.7 39.0139 177.3 39.4138 180.7 38.7138C183.1 38.3138 185.3 38.4139 186.9 38.6139Z",
  fill: "#22272E"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M182.3 58.7138C187.768 58.7138 192.2 54.1024 192.2 48.4138C192.2 42.7253 187.768 38.1138 182.3 38.1138C176.832 38.1138 172.4 42.7253 172.4 48.4138C172.4 54.1024 176.832 58.7138 182.3 58.7138Z",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M203 57.8138C206.535 57.8138 209.4 53.6053 209.4 48.4138C209.4 43.2223 206.535 39.0138 203 39.0138C199.465 39.0138 196.6 43.2223 196.6 48.4138C196.6 53.6053 199.465 57.8138 203 57.8138Z",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M196.8 46.3138C196.8 46.3138 195.5 44.5138 192 46.3138",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M172.8 45.5138L160.9 44.6138",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M188.3 65.7139C188.3 65.7139 183.8 65.4139 181.5 61.0139",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M183.8 52.2138C184.7 52.3138 185.5 51.6138 185.6 50.6138L185.7 49.6138C185.8 48.7138 185.1 47.9138 184.1 47.8138C183.2 47.7138 182.4 48.4138 182.3 49.4138L182.2 50.4138C182.1 51.4138 182.8 52.1138 183.8 52.2138Z",
  fill: "#22272E"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M198.6 52.5138C199.5 52.6138 200.3 51.9138 200.4 50.9138L200.5 49.9138C200.6 49.0138 199.9 48.2138 198.9 48.1138C198 48.0138 197.2 48.7138 197.1 49.7138L197 50.7138C197 51.6138 197.7 52.4138 198.6 52.5138Z",
  fill: "#22272E"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M161.8 45.9138C161.8 45.9138 158.9 40.9138 155 42.2138C151.1 43.5138 151.2 49.5139 153.1 53.1139C155.5 57.7139 161 59.1138 163.9 58.6138",
  fill: "#B28D93"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M154.9 49.5139C154.7 49.0139 154.6 48.5138 154.7 47.9138C154.7 47.6138 154.9 47.3139 155.1 47.0139C155.4 46.7139 155.8 46.5139 156.2 46.5139C156.9 46.5139 157.6 46.8139 158 47.3139C158.4 47.7139 158.7 48.2139 159 48.7139C159.5 49.6139 159.7 50.5139 160 51.3139C160.2 51.7139 160.3 52.0139 160.5 52.2139C160.7 52.4139 161.2 52.4138 161.7 52.4138C161.4 52.8138 160.9 53.2139 160.2 53.1139C159.5 52.9139 159.1 52.5139 158.7 52.1139C158.1 51.2139 157.7 50.4139 157.3 49.6139C156.9 48.8139 156.5 48.2139 156.1 48.1139C156 48.1139 155.9 48.0139 155.8 48.1139C155.7 48.1139 155.6 48.2138 155.5 48.4138C155.3 48.5138 155.1 49.0139 154.9 49.5139Z",
  fill: "#22272E"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M214.1 132.814C214.1 132.814 212.2 132.314 210.8 132.214C209.4 132.014 208.4 132.214 208.4 132.214",
  stroke: "#896068",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M218.7 125.314C218.7 125.314 208.5 127.514 207.6 128.214",
  stroke: "#896068",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M217.5 120.514C217.5 120.514 210.5 122.014 210.1 122.114C208.8 122.514 206.4 123.214 206.4 123.214",
  stroke: "#896068",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M137.9 250.214C137.9 250.214 149.6 245.214 149.6 228.214",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M25.7 389.414L19.9 509.814C19.8 511.214 20.9 512.314 22.3 512.314C23.5 512.314 24.6 511.414 24.7 510.114L34.8 389.314H25.7V389.414Z",
  fill: "#77A1E3"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M82.8 389.414L88.6 509.814C88.7 511.214 87.6 512.314 86.2 512.314C85 512.314 83.9 511.414 83.8 510.114L73.7 389.314H82.8V389.414Z",
  fill: "#77A1E3"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M64.7 365.714L64.6 486.214C64.6 487.614 63.5 488.614 62.1 488.614C60.9 488.514 59.9 487.514 59.8 486.314L55.6 365.214L64.7 365.714Z",
  fill: "#77A1E3"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M86.8 377.714C77.6 376.414 65.8 375.614 52.8 375.614C39.9 375.614 28 376.414 18.8 377.714H0V384.514C0 389.414 23.6 393.414 52.8 393.414C81.9 393.414 105.6 389.414 105.6 384.514V377.714H86.8Z",
  fill: "#22272E"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M52.8 386.614C81.9606 386.614 105.6 382.629 105.6 377.714C105.6 372.799 81.9606 368.814 52.8 368.814C23.6394 368.814 0 372.799 0 377.714C0 382.629 23.6394 386.614 52.8 386.614Z",
  fill: "#63737A"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M90.5 471.714C90.5 471.714 89.2 481.314 87.4 484.214C85.5 487.114 82.6 494.314 82.7 496.014C83 499.114 92.6 507.014 98.2 511.814C103.8 516.614 108.4 516.814 118.8 517.614C129.2 518.414 133.4 516.814 133.4 513.614C133.4 510.514 131.3 508.914 126.7 503.614C122.2 498.314 114.9 490.814 112.5 486.514C110.1 482.214 114.9 475.714 117.1 471.714C119.3 467.714 95.1 460.414 90.5 471.714Z",
  fill: "#22272E"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M117.1 471.714C115 475.714 110.2 482.214 112.5 486.514C112.7 486.914 113 487.314 113.2 487.714C112.6 486.914 110.5 484.314 106.4 484.314C101.6 484.314 99 489.914 95.3 487.214C92.9 485.414 89.8 483.414 88 482.314C89.4 478.414 90.3 471.614 90.3 471.614C95.1 460.414 119.3 467.714 117.1 471.714Z",
  fill: "#F7D4D9"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M86.9 308.414C86.9 308.414 91.1 318.614 93.2 321.514C95.3 324.414 146.8 329.414 152.3 350.314C157.8 371.214 125.2 459.414 121.7 467.714C118.2 476.014 117.7 483.314 105.9 482.114C94 480.814 84.6 473.314 86.9 465.014C89.2 456.714 98.2 434.614 101.9 408.114C105.7 381.614 119 376.014 95 367.914C71 359.814 51.9 362.414 58.5 340.014C65.1 317.614 82.3 306.014 86.9 308.414Z",
  fill: "#F6AE2D"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M124.1 486.314C124.1 486.314 128.3 501.314 128.3 502.914C128.3 504.614 125.6 517.414 126.2 521.214C126.8 525.014 132 527.114 138.9 533.414C146.3 540.314 152.3 539.914 161.4 539.214C169.2 538.614 179.6 534.814 180.7 531.714C181.9 528.514 180.6 526.414 174.4 523.114C168.9 520.114 155.1 504.814 154.4 503.114C153.7 501.414 149.5 479.114 149.3 477.014C149.1 474.814 121.6 480.614 124.1 486.314Z",
  fill: "#22272E"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M153.7 501.014C151.6 498.414 148.6 496.214 144.6 498.614C140.4 501.114 140 506.514 137.8 506.814C135.6 507.114 135.4 504.014 132.5 503.114C129.6 502.314 127.8 500.314 127.8 500.314C126.7 495.614 124.1 486.214 124.1 486.214C121.6 480.514 149.1 474.714 149.2 476.914C149.4 478.814 152.4 495.014 153.7 501.014Z",
  fill: "#F7D4D9"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M160.4 511.914C160.4 511.914 155.2 509.914 145 515.014",
  stroke: "white",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M167.6 518.314C167.6 518.314 159.9 516.314 149.7 521.414",
  stroke: "white",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 306.814C16.5 306.814 11.7 319.414 8.8 327.314C5.9 335.214 2.19999 351.414 10.5 364.514C18.8 377.614 34.8 379.914 60.5 383.114C85.9 386.214 91.4 388.214 91.4 388.214C91.4 388.214 97.2 414.114 106.6 439.514C116 464.914 119.5 479.714 119.9 483.314C120.3 486.814 122.2 490.414 128.5 491.914C134.8 493.414 151.2 489.814 152.3 482.514C153.3 475.214 146.3 452.914 141.7 423.314C137.1 393.714 135 368.914 126.3 357.414C117.5 345.914 83.3 344.714 83.3 341.414C83.2 338.214 33.2 298.814 16.5 306.814Z",
  fill: "#F6AE2D"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M141.6 423.314C137 393.714 134.9 368.914 126.2 357.414C117.4 345.914 84.9 342.714 83.2 341.414C83.2 341.414 75.2 335.914 64.1 336.014",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M83.2 341.414C83.2 341.414 84 336.214 83.2 333.814",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 345.314C10.5 345.314 27.2 345.014 30.9 326.814",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M91.3 388.214C91.3 388.214 91.1 383.614 95.1 380.114",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M125.7 502.314C125.7 502.314 123.6 496.614 106.8 501.214",
  stroke: "white",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M117.3 493.314C117.3 493.314 115.7 489.114 102.3 494.814",
  stroke: "white",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M524.4 126.814L389.8 121.314C386.9 121.214 384.9 118.514 385.3 115.214L396.3 34.3139C396.7 31.1139 399.5 28.5139 402.4 28.3139L537 22.8139C540.7 22.6139 543.3 25.4139 542.9 29.0139L531.9 120.314C531.5 124.114 528.1 127.014 524.4 126.814Z",
  fill: "#F8AB5D"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M522.1 125.114L387.5 119.614C384.6 119.514 382.6 116.814 383 113.514L394 32.6138C394.4 29.4138 397.2 26.8138 400.1 26.6138L534.7 21.1138C538.4 20.9138 541 23.7138 540.6 27.3138L529.6 118.614C529.2 122.414 525.8 125.214 522.1 125.114Z",
  fill: "#22272E"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M415.2 72.9138H450.8",
  stroke: "#F8AB5D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M447 102.214L427.8 101.714C424.8 101.614 422.8 99.0138 423.2 95.9138L429.3 50.0138C429.7 46.9138 432.4 44.3138 435.4 44.2138L454.6 43.7138",
  stroke: "#F8AB5D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M475.6 49.0138L453.3 49.4138C452 49.4138 451.2 48.4138 451.3 47.1138L452.2 40.4138C452.4 39.1138 453.5 38.0138 454.8 38.0138L477.1 37.3138C478.4 37.3138 479.3 38.3138 479.2 39.6138L478.3 46.4138C478.1 47.9138 476.9 49.0138 475.6 49.0138Z",
  fill: "#F6AE2D"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M514 78.9138L490.1 78.8138C488.8 78.8138 487.8 77.7138 488 76.3138L488.9 69.3138C489.1 67.9138 490.3 66.8138 491.6 66.8138L515.5 66.7138C516.9 66.7138 517.9 67.8138 517.7 69.2138L516.8 76.3138C516.7 77.8138 515.4 78.9138 514 78.9138Z",
  fill: "#F6AE2D"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M468.1 108.614L445.8 108.014C444.5 108.014 443.7 106.914 443.8 105.614L444.7 98.8138C444.9 97.5138 446 96.4138 447.3 96.5138L469.6 96.9138C470.9 96.9138 471.8 98.0138 471.7 99.4138L470.8 106.314C470.6 107.614 469.4 108.614 468.1 108.614Z",
  fill: "#F6AE2D"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M475 72.8138H488.5",
  stroke: "#F8AB5D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M471.9 78.7139L449.6 78.6139C448.3 78.6139 447.5 77.5139 447.6 76.2139L448.5 69.5139C448.7 68.2139 449.8 67.1139 451.1 67.1139L473.4 67.0139C474.7 67.0139 475.6 68.1138 475.5 69.4138L474.6 76.3139C474.4 77.6139 473.2 78.7139 471.9 78.7139Z",
  fill: "#F7D4D9"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M415.2 72.9138C415.7 69.2138 413.3 66.3138 409.9 66.3138C406.5 66.3138 403.4 69.3138 402.9 72.9138C402.4 76.5138 404.7 79.5138 408.1 79.5138C411.5 79.5138 414.7 76.6138 415.2 72.9138Z",
  fill: "#F6AE2D"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M511.2 370.114V376.914C511.2 381.314 489.1 384.914 461.7 384.914C434.4 384.914 412.2 381.314 412.2 376.914V370.114H435.5C443.1 369.314 452.1 368.914 461.7 368.914C471.3 368.914 480.3 369.314 487.9 370.114H511.2Z",
  fill: "#22272E"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M461.7 378.114C489.038 378.114 511.2 374.532 511.2 370.114C511.2 365.696 489.038 362.114 461.7 362.114C434.362 362.114 412.2 365.696 412.2 370.114C412.2 374.532 434.362 378.114 461.7 378.114Z",
  fill: "#63737A"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M461.7 458.914C460.4 458.914 459.4 457.914 459.4 456.614V378.214H464.1V456.614C464.1 457.914 463 458.914 461.7 458.914Z",
  fill: "#22272E"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M461.7 456.414C461.7 456.414 434.5 458.414 425.9 476.514",
  stroke: "#22272E",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M497.6 476.514C488.9 458.414 461.8 456.414 461.8 456.414C461.8 456.414 457.3 459.914 455.4 480.614",
  stroke: "#22272E",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M456.972 489.96C460.895 489.034 463.325 485.102 462.399 481.178C461.472 477.255 457.54 474.825 453.617 475.751C449.693 476.678 447.263 480.61 448.19 484.533C449.116 488.457 453.048 490.887 456.972 489.96Z",
  fill: "#F6AE2D"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M502.716 483.157C505.567 480.306 505.567 475.684 502.716 472.833C499.865 469.982 495.243 469.982 492.392 472.833C489.541 475.684 489.541 480.306 492.392 483.157C495.243 486.008 499.865 486.008 502.716 483.157Z",
  fill: "#F6AE2D"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M427.569 485.061C431.492 484.135 433.922 480.203 432.995 476.28C432.069 472.356 428.137 469.926 424.214 470.853C420.29 471.779 417.86 475.711 418.787 479.635C419.713 483.558 423.645 485.988 427.569 485.061Z",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M488.7 296.414C493.5 307.914 502 326.414 501.9 347.214C501.9 372.414 471.4 382.714 468.3 386.714C465.2 390.814 401.7 395.114 395.2 382.414C388.7 369.614 389.1 356.314 406.5 324.214C418.1 302.714 416.6 296.714 416.7 296.414C416.7 296.414 418.3 298.114 419 291.414C419.7 284.714 485.8 289.614 488.7 296.414Z",
  fill: "#22272E"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M410.3 356.314C404.1 357.314 393.7 360.614 392.6 377.114C391.6 393.614 404.7 457.614 404.9 468.914C405.1 480.214 404 480.714 396.3 487.614C388.6 494.514 373.3 502.014 374.6 507.314C375.9 512.614 393.4 517.114 404.9 515.014C416.5 512.914 419 499.814 421.2 498.714C423.4 497.614 424.8 493.514 425.1 490.914C425.4 488.214 433.5 396.514 434.3 383.014C435.4 366.314 428.5 353.414 410.3 356.314Z",
  fill: "#F7D4D9"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M425.9 483.114C425.5 487.514 425.2 490.314 425.2 490.814C424.9 493.514 423.5 497.514 421.3 498.614C419.1 499.714 416.6 512.814 405 514.914C393.4 517.014 375.9 512.514 374.7 507.214C373.7 503.114 382.8 497.614 390.5 492.114C390.3 492.314 388.1 494.514 390.5 495.014C393 495.514 397.5 493.614 406.1 498.414C414.7 503.214 417.2 495.714 418.9 490.614C420.4 486.314 423.4 487.714 425.9 483.114Z",
  fill: "#22272E"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M440.5 359.314C433 364.314 430 370.414 428.6 393.414C426.7 425.014 423.3 474.714 421.7 480.014C420.1 485.314 418.1 487.714 416.2 493.014C414.3 498.314 398.2 513.614 399.2 519.414C400.1 525.214 409.4 531.014 415.2 532.914C421 534.814 427.9 535.614 432.1 532.914C436.3 530.214 438.4 513.314 439.5 509.314C440.6 505.214 441.8 502.314 442.8 495.214C443.7 488.214 451.1 456.114 454.2 446.914C457.3 437.814 471.2 393.014 471.6 375.514C471.8 358.014 451.5 352.114 440.5 359.314Z",
  fill: "#F7D4D9"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M440.5 359.314C433 364.314 430 370.414 428.6 393.414C426.7 425.014 423.3 474.714 421.7 480.014C420.1 485.314 418.1 487.714 416.2 493.014",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M443.9 488.914C443.3 491.714 442.9 493.914 442.8 495.214C441.9 502.214 440.6 505.214 439.5 509.314C438.4 513.414 436.4 530.314 432.2 532.914C428 535.614 421.1 534.814 415.3 532.914C409.5 531.014 400.3 525.214 399.3 519.514C398.6 515.314 406.8 506.214 412.1 499.414C411.8 499.814 408 505.514 414.8 510.514C420.7 514.914 431.7 517.614 434.5 511.014C437.3 504.414 438.8 498.214 440.1 496.214C441.4 494.314 443 492.214 443.9 488.914Z",
  fill: "#22272E"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M423.944 514.018C424.725 511.892 423.046 509.32 420.195 508.273C417.344 507.226 414.399 508.1 413.618 510.225C412.838 512.351 414.516 514.923 417.368 515.97C420.219 517.018 423.163 516.143 423.944 514.018Z",
  fill: "white"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M401.7 497.014C401.4 499.114 398.8 500.414 396 500.014C393.2 499.614 391.1 497.514 391.4 495.414C391.7 493.314 394.3 492.014 397.1 492.414C400 492.814 402 494.914 401.7 497.014Z",
  fill: "white"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M419.1 212.814C419.1 212.814 405.5 213.014 396.3 233.314C387.1 253.514 372.5 282.214 374.6 294.314C376.7 306.414 404.6 294.314 417.8 271.614C430.9 248.914 429.7 213.414 419.1 212.814Z",
  fill: "#F6AE2D"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M429.6 172.414C429.6 172.414 422.7 172.014 420.5 163.114C418.3 154.214 427.4 143.114 435.8 140.414C444.2 137.714 446.3 142.914 451.8 143.514C457.3 144.114 472 142.514 477.9 155.614C483.8 168.714 474 181.114 481.5 190.914C489 200.814 495.3 218.914 473.2 226.714C451.1 234.514 425.7 228.414 417.8 214.314C410 200.214 425.1 191.914 427.4 184.614C429.9 177.414 431 175.614 429.6 172.414Z",
  fill: "#22272E"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M452 207.614C452 207.614 431.6 207.414 420.5 211.614C417.2 212.814 414.4 214.914 413.6 225.314C412.9 234.714 412.4 234.614 409.8 239.214C405.7 246.614 404 255.114 411.9 268.914C417 277.914 415.4 294.814 414.6 303.314C413.8 311.914 414.8 315.614 431.3 319.814C447.8 324.014 483.2 319.814 487.2 315.814C491.2 311.814 493 272.214 492.2 264.514C491.4 256.814 506.2 236.314 505.1 228.214C504.1 220.114 494.4 209.014 452 207.614Z",
  fill: "#1D62D1"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M440.8 205.914C440.8 205.914 431.6 206.314 428.6 209.414C426.5 211.614 428.2 213.014 430.7 214.914C432.4 216.214 426.4 219.614 429.5 223.514C431.8 226.414 437 222.814 439 225.514C441.3 228.714 441.7 229.914 445.2 230.014C449.6 230.114 450 225.414 453.3 225.914C457.3 226.514 458.2 227.914 461.1 227.614C465.6 227.114 465.7 222.614 465.1 219.914C464.5 217.214 466.1 217.114 469.6 216.114C473.1 215.114 473.8 208.314 460.9 206.414C448.1 204.514 440.8 205.914 440.8 205.914Z",
  fill: "white"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M463.6 187.814C463.6 187.814 461.5 197.914 461.7 208.714C461.7 208.714 458.2 219.214 446.2 218.514C435 217.914 437.6 208.914 437.6 208.914C437.6 208.914 440.3 198.914 440.4 196.314C440.6 193.714 460.8 185.114 463.6 187.814Z",
  fill: "#F7D4D9"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M454.7 199.214C449.9 202.414 444.3 204.314 439 203.914C438.3 206.614 437.7 208.914 437.7 208.914C437.7 208.914 437.6 209.414 437.5 210.214C445.3 210.014 452.3 206.514 454.7 199.214Z",
  fill: "#E26E85"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M428.3 162.414C428.3 162.714 428.6 170.414 427.2 179.014C425.8 187.614 427.3 201.214 436.6 204.414C449.5 208.814 462.9 200.014 466.2 187.214C469.5 174.414 471.2 158.714 454.8 154.014C438.3 149.214 429.2 156.114 428.3 162.414Z",
  fill: "#F7D4D9"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M427.8 166.014C427.8 166.014 427.1 162.914 430 162.314C432.9 161.714 435.6 160.414 438.3 159.214C440.2 158.314 442.6 158.614 444.5 162.814C448.7 171.814 454 185.314 465 181.514C465 181.514 469.2 182.414 470.4 175.414C471.6 168.414 471.1 159.014 458.9 153.314C446.7 147.714 432.7 151.514 430.1 154.414C426.1 158.914 427.8 166.014 427.8 166.014Z",
  fill: "#22272E"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M460.3 182.914C460.3 182.914 464.8 176.714 469 180.314C473.2 183.914 467.4 193.014 461.6 192.714",
  fill: "#F7D4D9"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M466.8 193.414C466.8 192.014 465.6 189.414 464.2 189.414C462.8 189.414 461.6 192.014 461.6 193.414C461.6 194.814 462.8 196.014 464.2 196.014C465.6 196.014 466.8 194.914 466.8 193.414Z",
  fill: "#1D62D1"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M467.5 184.514C467.1 184.314 466.8 184.014 466.5 183.914C466.2 183.714 465.9 183.814 465.8 183.914C465.7 183.914 465.7 184.014 465.6 184.114C465.5 184.214 465.4 184.314 465.4 184.414C465.3 184.614 465.3 184.814 465.2 185.114C465.1 185.714 465.2 186.514 465 187.414C464.9 187.914 464.6 188.414 464.1 188.714C463.6 189.014 463.1 188.814 462.7 188.714C463.1 188.514 463.4 188.314 463.5 188.014C463.6 187.814 463.6 187.514 463.6 187.214C463.6 186.614 463.4 185.814 463.5 184.914C463.5 184.414 463.7 183.914 464.1 183.414C464.3 183.214 464.5 183.014 464.7 182.814C465 182.714 465.3 182.514 465.6 182.514C466.3 182.514 466.8 182.914 467 183.314C467.4 183.714 467.5 184.114 467.5 184.514Z",
  fill: "#22272E"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M431.7 178.414C432.1 179.314 432.1 180.314 431.9 181.314C431.7 182.314 431.3 183.214 430.6 184.014C430.4 184.314 430.3 184.314 430.3 184.614C430.3 184.814 430.4 185.114 430.6 185.514C430.8 185.814 431 186.214 431.3 186.514C431.6 186.814 431.9 187.214 432.3 187.314C431.8 187.514 431.3 187.414 430.8 187.214C430.3 187.014 429.9 186.714 429.5 186.414C429.1 186.014 428.8 185.514 428.7 184.814C428.7 184.614 428.7 184.514 428.7 184.314C428.7 184.114 428.8 183.914 428.8 183.814C428.9 183.614 428.9 183.514 429 183.314C429.1 183.214 429.2 183.014 429.3 182.914C430.3 181.714 431 180.214 431.7 178.414Z",
  fill: "#22272E"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M436.2 192.614C436.2 192.614 439.9 193.114 442.6 190.814",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M440.5 170.814C440.3 170.214 440.6 169.314 440.9 168.914C441.7 167.914 444.3 167.814 446.3 169.114C448.3 170.314 449.1 172.214 448.5 172.414C447.6 172.714 446.7 171.514 444.6 171.314C442.5 171.014 440.9 171.914 440.5 170.814Z",
  fill: "#22272E"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M430.2 170.514C430.7 170.614 431.2 170.314 431.2 169.814C431.3 169.114 431.3 168.314 431 167.814C430.4 166.914 428.8 167.914 428.3 168.614C427.8 169.314 428 170.514 428.3 170.514C428.5 170.514 429.4 170.314 430.2 170.514Z",
  fill: "#22272E"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M442.5 180.214C443.3 180.314 443.9 179.714 444 178.914L444.1 178.114C444.2 177.314 443.6 176.714 442.8 176.614C442 176.514 441.4 177.114 441.3 177.914L441.2 178.714C441.2 179.514 441.7 180.214 442.5 180.214Z",
  fill: "#22272E"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M429.6 179.214C430.4 179.314 431 178.714 431.1 177.914L431.2 177.114C431.3 176.314 430.7 175.714 429.9 175.614C429.1 175.514 428.5 176.114 428.4 176.914L428.3 177.714C428.3 178.514 428.9 179.114 429.6 179.214Z",
  fill: "#22272E"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M293 334.914L298.8 470.514C298.9 472.014 297.8 473.314 296.4 473.314C295.2 473.314 294.1 472.214 294 470.814L283.9 334.814H293V334.914Z",
  fill: "#77A1E3"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M305.5 319.014L311 448.014C311.1 449.514 310 450.714 308.7 450.714C307.5 450.714 306.5 449.714 306.4 448.414L296.8 319.014H305.5V319.014Z",
  fill: "#77A1E3"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M202.1 335.014L183.9 469.514C183.7 471.014 184.7 472.414 186 472.514C187.2 472.614 188.4 471.614 188.6 470.314L211.1 335.814L202.1 335.014Z",
  fill: "#77A1E3"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M323.5 191.114C323.5 191.114 329.4 193.814 324.3 217.514C319.2 241.214 309.8 272.614 311.1 308.114C312.3 343.614 289.1 358.314 251 355.614C212.9 352.914 272.7 245.314 272.7 245.314C272.7 245.314 315.6 181.414 323.5 191.114Z",
  fill: "#77A1E3"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M221.3 198.314C222.3 193.914 224.4 186.814 232.3 183.914C240.2 181.014 323.2 182.414 324.3 192.714C325.3 202.914 303.7 251.014 303.8 285.414C303.9 319.714 310 348.314 269.5 354.014C229 359.714 185.6 351.314 190 337.514C194.4 323.814 207.8 305.214 211.9 267.314C216 229.414 217.6 215.314 221.3 198.314Z",
  fill: "white"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M202.5 308.414C202.5 308.414 172 346.614 171.1 359.314C170.2 372.014 221.2 371.514 221.3 368.914C221.5 366.314 229.9 351.514 233.9 351.214C236.5 351.014 240.5 350.814 241.2 354.014C242.2 358.514 241.2 367.914 241.2 367.914L285.1 388.514L289.4 370.214C289.4 370.214 296.8 358.314 296.8 338.714C296.8 319.114 291.1 290.214 291.1 290.214C291.1 290.214 207.5 299.014 202.5 308.414Z",
  fill: "#22272E"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M238.5 492.614C238.5 492.614 235.8 494.414 235.2 498.914C234.6 503.414 232.2 510.114 230.6 515.614C229 521.114 224.3 531.814 226.7 533.614C230.1 536.314 239.1 538.214 249.5 539.114C259.9 540.014 264.9 539.414 266.5 536.414C268 533.414 264.7 516.214 264.1 509.714C263.5 503.214 264.1 496.414 262.9 494.114C261.7 491.914 243.3 486.414 238.5 492.614Z",
  fill: "#22272E"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M201.6 486.814C201.6 486.814 200.4 488.714 199.2 492.714C198 496.614 187.4 513.014 187.5 518.214C187.7 523.514 197.7 523.514 201.6 523.714C206.3 523.914 218.2 523.014 222.1 520.314C226 517.614 226.1 508.314 226.4 505.314C227 499.314 226.9 495.714 225.5 486.714C225.1 483.814 220.7 483.014 218.3 484.714C215.9 486.314 203.4 482.914 201.6 486.814Z",
  fill: "#22272E"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M240.1 480.714C240.1 480.714 238.3 493.814 238.1 495.414C237.9 496.914 240.8 500.514 249.2 502.314C256.4 503.914 260.7 501.214 261.4 500.214C262.1 499.214 265.4 482.514 266.5 478.714C267.6 475.014 242.4 476.214 240.1 480.714Z",
  fill: "#F7D4D9"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M199.2 477.914C199.2 477.914 201.9 487.114 201.9 488.314C201.9 489.514 206.5 492.014 212.9 491.814C219.2 491.614 224.7 488.114 224.7 486.414C224.7 484.714 222.8 468.414 222.8 468.414C222.8 468.414 199.8 473.314 199.2 477.914Z",
  fill: "#F7D4D9"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M236.4 515.914C236.4 515.914 248.7 511.814 260.3 521.414",
  stroke: "white",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M239.6 508.614C239.6 508.614 251.7 506.414 259.4 512.714",
  stroke: "white",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M238.6 497.914C238.6 497.914 240.6 499.114 242.9 497.914C245.2 496.714 247.6 494.514 252.3 495.414C258 496.514 259.1 502.414 262.2 499.814C262.2 499.814 262.3 503.814 254.5 504.214C246.7 504.614 238.7 499.214 238.6 497.914Z",
  fill: "#22272E"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M201.5 488.514C201.5 488.514 202.6 489.714 204.4 488.014C206.2 486.414 206 484.414 210.9 483.714C214.1 483.314 216.8 485.614 219.2 487.514C221.6 489.414 224 486.814 224.5 484.614C224.5 484.614 226.1 490.314 223.9 493.114C222.3 495.214 216.1 493.714 212.4 493.814C208.8 493.914 200.7 492.114 200.7 492.114L201.5 488.514Z",
  fill: "#22272E"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M194.7 503.214C194.7 503.214 204.1 497.414 217 505.214",
  stroke: "white",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M199.2 497.214C199.2 497.214 207.4 491.414 218.7 499.214",
  stroke: "white",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M253 348.214C253 348.214 240.9 349.914 240.1 380.114C239.3 410.314 236.8 458.814 233.4 465.614C230.1 472.414 231.2 480.414 237.5 483.614C243.8 486.814 251.1 490.514 260.3 489.514C269.5 488.614 273.9 483.214 273.9 472.514C273.9 461.714 277.8 431.814 283.8 407.414C289.7 383.014 293.8 358.914 281.6 350.214C269.4 341.514 253 348.214 253 348.214Z",
  fill: "#22272E"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M181.3 345.814C181.3 345.814 163.1 348.114 173.4 393.214C183.7 438.214 190.6 462.014 189 468.914C187.4 475.814 192.4 479.514 198.1 480.814C203.7 482.114 214.7 481.914 220.9 478.414C227.2 474.914 227.8 469.314 225.3 458.614C222.8 447.914 222.2 405.114 221.9 390.414C221.6 375.714 225.3 350.714 207.5 343.514C189.6 336.214 181.3 345.814 181.3 345.814Z",
  fill: "#22272E"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M192.7 375.614C200.708 375.614 207.2 369.211 207.2 361.314C207.2 353.416 200.708 347.014 192.7 347.014C184.692 347.014 178.2 353.416 178.2 361.314C178.2 369.211 184.692 375.614 192.7 375.614Z",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M264.4 386.614C272.408 386.614 278.9 380.211 278.9 372.314C278.9 364.416 272.408 358.014 264.4 358.014C256.392 358.014 249.9 364.416 249.9 372.314C249.9 380.211 256.392 386.614 264.4 386.614Z",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M297.8 159.314C297.8 159.314 303.7 157.414 305.6 153.114C307.6 148.814 307.3 135.814 303.8 131.714C300.3 127.614 290.5 129.414 284.3 127.614C278.1 125.814 273.8 121.814 262.3 124.014C250.8 126.214 240.2 136.514 239.7 142.114C239.2 147.714 242.5 150.014 241.3 153.614C240 157.114 238.5 160.714 244.1 166.214C249.7 171.714 247.5 175.314 251.7 175.314C255.9 175.314 248.3 162.514 253.7 151.514C259.2 140.614 294.8 146.914 297.8 159.314Z",
  fill: "#22272E"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M181.6 225.514C181.6 225.514 168.4 242.914 166.1 256.014C163.8 269.114 170.9 277.614 179.7 279.014C188.5 280.414 218 241.914 219.4 234.114C220.7 226.314 185.8 219.414 181.6 225.514Z",
  fill: "#F7D4D9"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M223.7 191.514C223.7 191.514 217 189.614 200.9 203.514C187.4 215.114 176.7 226.214 176.7 226.214C176.7 226.214 205.1 252.014 209 258.714C209 258.714 226.5 238.514 228 218.114C229.5 197.614 226.2 190.714 223.7 191.514Z",
  fill: "#63737A"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M181.6 221.614C181.6 221.614 202.1 238.114 213.2 253.314",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M215.8 200.014C218.3 194.414 223.3 190.314 229.5 190.114C235.5 189.914 244.6 190.014 257.8 190.914C286.2 192.914 308.1 201.014 313.9 205.214C319.7 209.414 312.6 235.414 306.6 249.814C300.6 264.214 294.1 277.314 293 282.314C292 287.314 295.9 310.914 293.8 315.714C291.7 320.514 269.4 328.814 241 327.214C212.6 325.514 200.8 316.414 199.9 313.014C199.1 309.714 202.6 280.114 204.3 270.014C206 259.914 207.2 237.714 207.4 234.514C209.2 213.914 213.2 205.814 215.8 200.014Z",
  fill: "#22272E"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "M339.8 246.514C332.7 234.314 308.1 258.614 308.7 264.014C308.7 264.014 313.1 273.214 313.1 274.214C313.1 275.214 308.7 300.514 305.7 314.714C304.8 319.114 302.1 324.014 298.8 328.714C306.6 331.614 314.5 334.014 322.6 335.614C333.2 317.114 345.4 288.814 347.3 281.814C350.8 268.714 346.9 258.714 339.8 246.514Z",
  fill: "#F7D4D9"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M313.1 274.214C313.1 274.214 314.9 269.914 319.5 268.014",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  d: "M313.9 205.114C313.9 205.114 322 209.614 330 223.114C337.9 236.614 344.2 248.914 344.2 248.914L309 267.314C309 267.314 298.8 250.614 294.6 243.114C290.4 235.614 290 220.214 295.9 211.614C301.6 203.114 311.1 203.214 313.9 205.114Z",
  fill: "#63737A"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M305.7 262.014C305.7 262.014 326.2 248.514 341.3 243.514",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  d: "M303.7 320.314C303.7 320.314 289.6 321.714 286.4 323.514C283.3 325.314 278.4 336.214 278.8 337.214C279.1 338.214 282.2 337.214 282.2 337.214C282.2 337.214 281.8 339.314 284.2 339.314C286.6 339.314 287 338.314 287 338.314C287 338.314 286.6 340.914 289.4 340.814C292.2 340.614 298 335.614 298 335.614C298 335.614 294.9 341.114 296.8 342.414C298.6 343.714 302.8 339.114 303.4 338.214C304 337.314 319.9 346.914 326 329.214C326 329.214 314.5 316.714 303.7 320.314Z",
  fill: "#F7D4D9"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M244.4 189.514C244.4 189.514 239.6 190.014 238.6 190.914C237.6 191.814 234.6 199.614 238.6 207.714C242.6 215.714 254.2 219.814 266 216.114C277.8 212.514 282.8 201.114 282.4 197.614C282 194.114 279.9 193.014 275.6 191.914C271.3 190.814 244.4 189.514 244.4 189.514Z",
  fill: "#63737A"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M250.1 164.414C250.1 164.414 250.4 173.614 248.1 181.114C247.1 184.514 245.5 187.614 244.5 189.414C243.7 190.914 243.1 192.514 242.9 194.114C242.3 198.214 242.6 205.314 250.1 208.714C262.1 214.114 274.7 204.214 276.4 196.314C276.4 196.314 277.1 188.114 278.9 184.814C280.7 181.614 255.9 161.314 250.1 164.414Z",
  fill: "#F7D4D9"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M275.6 198.614C276 197.814 276.2 197.014 276.4 196.314C276.4 196.314 276.5 194.714 276.9 192.614C268.6 191.214 261.3 186.414 256.8 179.914C257.4 189.714 265.8 197.214 275.6 198.614Z",
  fill: "#E26E85"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  d: "M174.8 277.414C174.8 277.414 179.7 282.914 201.5 277.414C223.2 271.914 251.4 256.714 255.6 255.214C259.8 253.614 261.4 254.414 265.9 254.414C276.6 254.614 281 253.614 282.4 252.914C285.2 251.514 286.5 249.414 286 247.614C285.5 245.814 287 245.314 287.3 243.714C287.8 240.714 286.7 240.314 287 240.114C287.3 239.914 290.3 239.014 290.9 238.214C292.4 235.914 291.2 234.414 291.2 234.414C291.2 234.414 295 233.414 299.5 233.014C304 232.614 306.7 231.014 305.4 229.414C304.1 227.814 295.3 228.314 289.6 228.314C283.9 228.314 281.9 228.414 281.5 228.214C279.3 227.514 275 226.214 272.9 226.414C270.8 226.614 268.4 228.314 264.3 230.514C260.2 232.714 255.6 234.514 249.6 236.014C245 237.214 214.1 239.614 195 243.214C192.3 243.714 189.8 244.214 187.7 244.814C185.1 245.514 183 246.214 181.6 246.914C171.2 252.514 162.1 267.214 174.8 277.414Z",
  fill: "#F7D4D9"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  d: "M291.1 234.414C291.1 234.414 288.5 234.014 287.6 233.814C286.6 233.614 285.2 233.614 285.2 233.614",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  d: "M287 240.114C287 240.114 285.2 240.614 284.5 240.914",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  d: "M286 246.514C286 246.514 284.1 247.614 283.3 247.914",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  d: "M255.6 255.214C247.9 246.114 251.8 235.414 251.8 235.414L243.2 237.014C238.3 249.114 247 259.314 247 259.314L255.6 255.214Z",
  fill: "#22272E"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  d: "M281.4 228.214C281.4 228.214 276 228.314 275.1 228.714",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  d: "M195 243.214C192.3 243.714 189.8 244.214 187.7 244.814C185.1 245.514 183 246.214 181.6 246.914",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  d: "M251.6 246.514C251.6 243.614 249.3 241.314 246.4 241.314C243.5 241.314 241.2 243.614 241.2 246.514C241.2 249.414 243.5 251.714 246.4 251.714C249.2 251.614 251.6 249.314 251.6 246.514Z",
  fill: "white"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  d: "M299 142.314C299 142.314 301.2 148.914 298.1 158.714C295 168.614 292.9 172.214 290.3 180.014C287.6 187.814 281.4 194.614 270.7 193.514C259.5 192.314 250.7 182.114 250.2 169.414C249.7 156.714 248.6 136.914 263.7 133.414C278.6 130.014 296.4 138.914 299 142.314Z",
  fill: "#F7D4D9"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  d: "M289.1 163.514C289.1 164.714 289.1 165.814 289.3 166.914C289.4 167.414 289.5 168.014 289.6 168.514C289.7 168.814 289.7 169.014 289.8 169.314L289.9 169.714L290 170.214C290.2 170.914 290.2 171.614 290 172.414C289.7 173.114 289.2 173.814 288.6 174.114C287.4 174.814 286.1 174.914 284.9 174.614C286 174.114 287.1 173.614 287.7 173.014C288.4 172.314 288.5 171.614 288.2 170.714L288.1 170.414L288 169.914C287.9 169.614 287.9 169.314 287.8 169.014C287.7 168.414 287.7 167.714 287.7 167.114C288 165.714 288.4 164.414 289.1 163.514Z",
  fill: "#22272E"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "M252.8 158.114C252.8 158.114 256.1 157.314 258.2 148.614C258.2 148.614 258.9 146.614 262.4 149.314C265.8 152.014 271.7 156.414 281.9 151.614C292.1 146.814 293.4 145.214 294.8 146.914C294.8 146.914 296.3 154.514 301.5 152.114C306.7 149.814 303.9 136.214 286.7 131.814C269.5 127.414 257.3 128.914 251.8 138.514C246.2 148.214 248.4 157.514 252.8 158.114Z",
  fill: "#22272E"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  d: "M284.2 154.914C284.8 154.214 285.4 152.614 284.6 151.514C283.5 149.814 276 148.614 274.2 150.114C272.4 151.614 276.9 151.814 279 152.814C281.1 153.914 283.6 155.614 284.2 154.914Z",
  fill: "#22272E"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  d: "M293.5 159.214C293.7 158.614 294.3 157.914 295 157.614C296.1 157.114 298.4 159.414 298 160.914C297.6 162.414 296.5 160.714 295.5 160.514C294.5 160.114 293.2 159.814 293.5 159.214Z",
  fill: "#22272E"
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  d: "M278.5 160.714C278.8 159.914 278.4 159.014 277.5 158.714C276.7 158.414 275.8 158.814 275.5 159.714L275.3 160.214L278.2 161.314L278.5 160.714Z",
  fill: "#22272E"
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  d: "M293.5 166.314C293.8 165.514 293.4 164.614 292.5 164.314C291.7 164.014 290.8 164.414 290.5 165.314L290.3 165.814L293.2 166.914L293.5 166.314Z",
  fill: "#22272E"
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  d: "M254.6 159.814C254.6 159.814 252.9 153.014 247.9 153.114C242.9 153.214 240.6 166.814 252.1 168.914",
  fill: "#F7D4D9"
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  d: "M247.1 159.314C247.1 158.814 247.2 158.414 247.6 157.914C247.8 157.714 248.1 157.514 248.5 157.514C248.8 157.514 249.2 157.614 249.4 157.714C249.5 157.714 249.7 157.914 249.8 158.014C250 158.114 250 158.314 250.1 158.414C250.2 158.614 250.2 158.714 250.3 158.814C250.3 158.914 250.4 159.114 250.4 159.214C250.5 159.714 250.5 160.114 250.5 160.514C250.5 161.314 250.5 162.114 250.5 162.814C250.5 163.114 250.6 163.414 250.8 163.714C251 164.014 251.3 164.214 251.7 164.414C251.3 164.614 250.8 164.614 250.3 164.414C249.8 164.214 249.4 163.714 249.2 163.214C248.8 162.314 248.7 161.414 248.7 160.514C248.7 159.714 248.6 158.814 248.6 158.814C248.4 158.614 248.3 158.514 248 158.514C247.8 158.714 247.5 159.014 247.1 159.314Z",
  fill: "#22272E"
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  d: "M278.2 181.114C278.6 180.514 279 179.914 279.2 179.414C279.6 178.514 279.2 177.514 278.3 177.214C277.3 176.814 276 176.114 274.5 174.914C271.4 172.414 270 174.614 270.2 177.414C273.2 177.714 275.9 179.614 278.2 181.114Z",
  fill: "#22272E"
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  d: "M270.2 177.314C270.4 179.714 271.7 182.614 274.3 183.014C276 183.314 277.3 182.314 278.2 181.114C275.9 179.614 273.2 177.714 270.2 177.314Z",
  fill: "#E26E85"
});

var _ref162 = /*#__PURE__*/React.createElement("path", {
  d: "M70.5 342.914L55.8 547.914C55.7 549.614 57.1 551.114 58.8 551.114C60.4 551.114 61.7 549.914 61.8 548.414L79.5 343.014H70.5V342.914Z",
  fill: "#77A1E3"
});

var _ref163 = /*#__PURE__*/React.createElement("path", {
  d: "M663.8 342.914L678.5 547.914C678.6 549.614 677.2 551.114 675.5 551.114C673.9 551.114 672.6 549.914 672.5 548.414L654.8 343.014H663.8V342.914Z",
  fill: "#77A1E3"
});

var _ref164 = /*#__PURE__*/React.createElement("path", {
  d: "M695.1 338.614H39.2L114.2 308.414H620L695.1 338.614Z",
  fill: "white"
});

var _ref165 = /*#__PURE__*/React.createElement("path", {
  d: "M695.2 338.614H39.2V346.114H695.2V338.614Z",
  fill: "#77A1E3"
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  d: "M300 303.414H342.1C343.2 303.414 344.3 303.714 345.3 304.414L383.5 329.914C384.8 330.714 384.2 332.714 382.7 332.714H321.8C320.4 332.714 319.1 332.114 318.2 330.914L298.8 305.914C298 304.914 298.7 303.414 300 303.414Z",
  fill: "#1D62D1"
});

var _ref167 = /*#__PURE__*/React.createElement("path", {
  d: "M326 324.814H365.3",
  stroke: "#F6AE2D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref168 = /*#__PURE__*/React.createElement("path", {
  d: "M354.4 317.314L346.2 311.114C345.8 310.814 345.4 310.714 345 310.714H334.3C333.9 310.714 333.8 311.114 334 311.414L340.2 317.414C340.6 317.814 341.1 318.014 341.6 318.014H354.2C354.6 318.014 354.7 317.614 354.4 317.314Z",
  fill: "#22272E"
});

var _ref169 = /*#__PURE__*/React.createElement("path", {
  d: "M332.2 318.014H321.4",
  stroke: "#F6AE2D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  d: "M328.7 313.914H319",
  stroke: "#F6AE2D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  d: "M543.1 336.814L531.1 337.714C530.1 337.814 529 337.714 528 337.414L473.2 322.414C472 322.114 471.1 320.914 471.1 319.614L564.3 317.314L543.1 336.814Z",
  fill: "#63737A"
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  d: "M529.7 333.414L552.9 271.714C553.7 269.514 555.9 268.014 558.2 268.114L653.4 269.914C655.5 269.914 657 272.114 656.1 274.114L634.1 328.014C633.3 330.014 631.4 331.314 629.3 331.514L532.7 337.614C530.6 337.614 529 335.414 529.7 333.414Z",
  fill: "#22272E"
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  d: "M533.1 337.614L531.1 337.714C530.1 337.814 529 337.714 528 337.414L473.2 322.414C472 322.014 471.1 320.914 471.1 319.614L531.2 334.014L533.1 337.614Z",
  fill: "#22272E"
});

var _ref174 = /*#__PURE__*/React.createElement("path", {
  d: "M610.2 301.414C609.1 305.214 605.2 308.314 601.4 308.314C597.6 308.314 595.4 305.214 596.5 301.414C597.6 297.614 601.5 294.514 605.3 294.514C609.1 294.414 611.3 297.614 610.2 301.414Z",
  fill: "#63737A"
});

var _ref175 = /*#__PURE__*/React.createElement("path", {
  d: "M73.2 206.014C73.2 206.014 83 203.314 91.6 218.714C100.2 234.114 104.5 262.714 107.2 265.614C109.9 268.514 114.3 270.714 128.5 279.814C142.7 288.914 143.5 289.214 155.8 290.714C168.1 292.214 168.9 296.414 172.7 300.614C176.5 304.814 179.2 307.714 175.6 308.014C172.1 308.314 168.1 303.114 165.8 304.614C163.5 306.114 161.8 307.314 157.7 308.414C153.5 309.414 154.8 311.114 150.9 310.714C147 310.314 139.4 310.514 141.8 308.414C144.1 306.314 141.8 305.814 141.8 305.814C141.8 305.814 99.5 300.114 85.8 289.014C72 277.914 68.5 241.114 65.8 228.914C63 216.614 69.8 206.014 73.2 206.014Z",
  fill: "#FFE7CA"
});

var _ref176 = /*#__PURE__*/React.createElement("path", {
  d: "M107.2 265.614C107.2 265.614 103.4 265.214 100.7 266.614",
  stroke: "#F8AB5D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref177 = /*#__PURE__*/React.createElement("path", {
  d: "M78 157.314C78 157.314 85.4 150.314 82.5 141.214C79.6 132.014 70.6 131.214 63.3 133.414C56 135.714 36 131.914 28.7 143.014C21.4 154.114 26 164.114 21.4 167.014C16.8 169.914 10.3 172.014 11.4 179.314C12.4 186.614 32 197.214 26 205.614C20 213.914 14.3 233.514 37.5 244.614C60.6 255.714 62.1 229.214 63.6 213.814C65.1 198.414 60.5 180.614 67.1 174.014C73.8 167.214 79.3 163.514 78 157.314Z",
  fill: "#22272E"
});

var _ref178 = /*#__PURE__*/React.createElement("path", {
  d: "M44.2 202.414C44.2 202.414 70.7 203.014 75.3 205.114C79.9 207.214 82 214.314 83.4 219.714C84.9 225.114 95.3 231.614 97.2 243.514C99.1 255.414 88.9 269.214 88.4 271.414C88 273.714 87.8 296.014 89 300.614C90.3 305.214 92.3 312.714 92.1 316.014C91.9 319.314 77.9 325.814 57.1 324.614C36.3 323.414 14.5 312.914 13.8 310.614C13.2 308.314 20 297.514 18.1 274.914C16.2 252.414 5.39998 228.014 13.3 214.614C21.2 201.414 40.2 202.314 44.2 202.414Z",
  fill: "#22272E"
});

var _ref179 = /*#__PURE__*/React.createElement("path", {
  d: "M43.2 183.414C43.2 183.414 44.3 195.014 44.1 202.414C44.1 202.414 47 208.614 56.1 210.414C67.1 212.714 69.3 206.414 67.8 203.714C67.8 203.714 65.2 194.114 64.9 187.514C64.7 181.114 43.7 182.514 43.2 183.414Z",
  fill: "#FFE7CA"
});

var _ref180 = /*#__PURE__*/React.createElement("path", {
  d: "M52.2 193.014C56.3 199.414 60.5 202.014 67.7 202.514C67.3 201.114 66.8 198.614 66.2 195.914C60.5 196.614 57.8 194.614 52.2 193.014Z",
  fill: "#F8AB5D"
});

var _ref181 = /*#__PURE__*/React.createElement("path", {
  d: "M39.4 202.414C39.4 202.414 45.2 206.214 51 214.414C56.7 222.614 64 228.714 69.1 228.114C74.2 227.514 76.6 220.814 70 204.014C70 204.014 54 201.414 39.4 202.414Z",
  fill: "#FFE7CA"
});

var _ref182 = /*#__PURE__*/React.createElement("path", {
  d: "M133.7 297.014L175.6 294.414C176.1 294.414 176.7 293.314 176.9 293.714C177 293.814 176.9 295.414 176.9 295.514C176.9 295.814 176.8 296.214 176.6 296.414L145 328.814C143.7 330.114 141.9 330.814 140 330.614L98.8 326.514C98.4 326.514 98 326.214 97.9 325.914C97.8 325.714 96.2 323.014 96.3 322.714C96.3 322.414 98.6 322.414 98.9 322.214L130.9 298.114C131.6 297.514 132.6 297.114 133.7 297.014Z",
  fill: "#63737A"
});

var _ref183 = /*#__PURE__*/React.createElement("path", {
  d: "M133.2 294.414L175.7 292.614C176.8 292.614 177.4 293.914 176.6 294.714L143.9 326.914C142.6 328.214 140.7 328.914 138.8 328.614L97.1 323.514C96 323.414 95.6 322.014 96.5 321.314L130.2 295.414C131 294.814 132.1 294.414 133.2 294.414Z",
  fill: "#22272E"
});

var _ref184 = /*#__PURE__*/React.createElement("path", {
  d: "M152 292.514C152 292.514 150.9 292.714 150.9 294.814C150.9 296.814 151.7 302.514 149.6 302.914C147.6 303.314 146.6 300.814 145.6 298.614C144.6 296.414 141.6 296.314 139.7 293.114",
  fill: "#FFE7CA"
});

var _ref185 = /*#__PURE__*/React.createElement("path", {
  d: "M75.4 146.614C75.4 146.614 78.3 154.314 78.6 163.014C78.9 171.814 81.9 176.814 80.2 184.414C78.5 192.114 72.5 197.914 65.1 198.214C57.7 198.514 46.9 191.914 41 184.014C35.1 176.014 33.3 159.614 36.8 151.614C40.1 143.714 66.3 135.414 75.4 146.614Z",
  fill: "#FFE7CA"
});

var _ref186 = /*#__PURE__*/React.createElement("path", {
  d: "M78.8 155.214C78.8 155.214 74.5 155.714 71.8 151.314C71.8 151.314 65.3 166.314 54.8 167.314C47.6 168.014 46.2 164.614 43.2 167.314C40.2 170.014 48.9 185.614 46.2 198.314C43.5 211.014 30.7 214.514 21.7 206.714C10.4 196.814 22.7 194.914 25 180.914C27.3 167.014 25 156.314 32.4 148.214C39.8 140.114 47.1 135.114 58.8 136.214C70.6 137.314 75.4 139.114 78.8 155.214Z",
  fill: "#22272E"
});

var _ref187 = /*#__PURE__*/React.createElement("path", {
  d: "M47.9 165.414C47.9 165.414 47.2 170.714 47.5 172.414C47.8 174.114 44.4 170.514 41.3 172.814C39.6 174.114 38 165.914 41.3 163.414C44.5 160.914 46.4 163.014 47.9 165.414Z",
  fill: "#22272E"
});

var _ref188 = /*#__PURE__*/React.createElement("path", {
  d: "M46 172.514C46 172.514 42.2 167.614 38.1 170.614C34 173.714 39.3 182.714 45.5 182.014",
  fill: "#FFE7CA"
});

var _ref189 = /*#__PURE__*/React.createElement("path", {
  d: "M130.1 319.914C130.1 319.914 135.8 324.614 138 326.214C140.1 327.814 138.8 329.214 136.4 329.214C133.9 329.314 126.1 322.914 130.1 319.914Z",
  fill: "#FFE7CA"
});

var _ref190 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8 210.514C14.4 211.614 12.5 213.514 11.2 215.814C8.8 220.314 5.4 229.114 7.9 240.514C11.6 257.414 20.3 282.814 24.2 288.814C28.1 294.814 46.4 306.814 59.3 314.814C72.2 322.814 82.1 327.214 84.5 329.014C87 330.814 91.7 335.414 100.8 336.514C110 337.614 112.9 334.314 115.7 335.014C118.6 335.714 123.2 338.914 125.8 338.614C128.4 338.214 127 336.314 126 335.314C125 334.314 119.1 329.014 119.1 329.014C119.1 329.014 122.7 330.514 127.9 333.614C132.3 336.214 134.4 336.314 135.6 336.214C136.8 336.214 138.2 335.714 138 334.614C138 334.614 139.2 335.314 140.2 334.414C141.2 333.514 141.5 332.714 139.1 330.014C136.6 327.314 130.6 320.214 127.6 317.114C124.5 313.914 121.1 313.714 113.7 314.114C106.3 314.414 95.9 312.914 95.6 313.214C95.3 313.514 63.5 279.814 53.9 270.214C53.9 270.214 46.2 245.114 43.9 234.314C39.2 212.614 27.8 205.314 16.8 210.514Z",
  fill: "#FFE7CA"
});

var _ref191 = /*#__PURE__*/React.createElement("path", {
  d: "M138 334.714C138 334.714 138 333.514 135 331.414C132 329.414 127.3 324.814 125.8 323.714C124.3 322.514 122.5 321.214 122.2 321.214",
  stroke: "#F8AB5D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref192 = /*#__PURE__*/React.createElement("path", {
  d: "M119.1 329.114C119.1 329.114 116.8 327.114 115.7 327.414",
  stroke: "#F8AB5D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref193 = /*#__PURE__*/React.createElement("path", {
  d: "M53.9 270.214C53.9 270.214 49.2 269.714 45.5 273.514",
  stroke: "#F8AB5D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref194 = /*#__PURE__*/React.createElement("path", {
  d: "M74.9 168.314C75.6 169.214 76.2 170.114 76.8 170.914C77.1 171.314 77.4 171.714 77.8 172.014C78 172.214 78.1 172.314 78.3 172.514L78.6 172.714C78.7 172.814 78.9 172.914 79 173.114C79.5 173.714 79.7 174.514 79.7 175.214C79.7 175.914 79.4 176.514 79.1 177.014C78.5 178.014 77.6 178.914 76.4 179.214C77.1 178.314 77.5 177.414 77.8 176.414C78.1 175.514 78 174.614 77.6 174.214C77.6 174.114 77.5 174.114 77.4 174.014C77.3 173.914 77.2 173.814 77 173.714C76.8 173.514 76.5 173.214 76.4 173.014C76 172.514 75.7 172.014 75.5 171.514C75.2 170.614 74.9 169.514 74.9 168.314Z",
  fill: "#22272E"
});

var _ref195 = /*#__PURE__*/React.createElement("path", {
  d: "M71.8 186.314C71.8 186.314 68.9 187.214 66.3 184.514",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref196 = /*#__PURE__*/React.createElement("path", {
  d: "M65 172.914C65.9 172.814 66.5 171.914 66.3 171.014L66.1 170.114C66 169.214 65.1 168.614 64.2 168.814C63.3 168.914 62.7 169.814 62.9 170.714L63.1 171.614C63.3 172.414 64.1 173.014 65 172.914Z",
  fill: "#22272E"
});

var _ref197 = /*#__PURE__*/React.createElement("path", {
  d: "M77.2 170.914C78.1 170.814 78.7 169.914 78.5 169.014L78.3 168.114C78.2 167.214 77.3 166.614 76.4 166.814C75.5 166.914 74.9 167.814 75.1 168.714L75.3 169.614C75.5 170.414 76.3 171.114 77.2 170.914Z",
  fill: "#22272E"
});

var _ref198 = /*#__PURE__*/React.createElement("path", {
  d: "M64.1 162.514C65 162.614 65.7 161.814 65.6 160.914C65.5 160.114 65.3 159.314 64.9 158.814C64 157.814 60.5 158.114 57.9 160.114C55.2 162.114 54.2 164.714 55.5 164.814C56.8 164.914 58.7 163.214 60.8 162.714C61.8 162.314 63.1 162.414 64.1 162.514Z",
  fill: "#22272E"
});

var _ref199 = /*#__PURE__*/React.createElement("path", {
  d: "M77.2 161.014C76.8 161.314 76.3 161.014 76.2 160.614C76 159.814 75.8 158.614 76.1 158.314C76.6 157.714 78.1 158.114 78.4 159.014C78.7 159.914 78.8 160.414 78.5 160.414C78.3 160.314 77.7 160.614 77.2 161.014Z",
  fill: "#22272E"
});

var _ref200 = /*#__PURE__*/React.createElement("path", {
  d: "M39.7 175.114C39.4 174.814 39.3 174.414 39.3 173.914C39.3 173.714 39.4 173.414 39.6 173.114C39.8 172.814 40 172.714 40.3 172.514C40.4 172.514 40.5 172.414 40.7 172.414C40.9 172.414 41.2 172.414 41.4 172.514C41.8 172.714 42 173.014 42.1 173.214C42.4 173.614 42.5 174.014 42.7 174.414C43 175.114 43.1 175.814 43.3 176.314C43.4 176.614 43.5 176.814 43.7 177.014C43.9 177.214 44.3 177.314 44.7 177.314C44.4 177.614 44 177.814 43.5 177.814C43 177.814 42.5 177.514 42.2 177.114C41.6 176.414 41.3 175.614 41 175.014C40.9 174.714 40.8 174.314 40.7 174.114C40.7 174.014 40.6 173.914 40.7 173.914H40.8H40.7C40.5 173.914 40.4 173.914 40.2 174.114C39.9 174.314 39.8 174.714 39.7 175.114Z",
  fill: "#22272E"
});

var _ref201 = /*#__PURE__*/React.createElement("path", {
  d: "M322.4 113.214H287.2L283.6 115.514C282.5 116.214 280.9 115.414 280.9 114.114V89.2138C280.9 86.7138 282.9 84.6138 285.5 84.6138H322.3C324.8 84.6138 326.9 86.6138 326.9 89.2138V108.614C326.9 111.214 324.9 113.214 322.4 113.214Z",
  fill: "#F7D4D9"
});

var _ref202 = /*#__PURE__*/React.createElement("path", {
  d: "M291.4 104.014L294.9 100.514C296.8 98.6138 299.8 98.6138 301.7 100.514C303.6 102.414 306.6 102.414 308.5 100.514L315.2 93.8138",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref203 = /*#__PURE__*/React.createElement("path", {
  d: "M316.3 95.8138L317.5 91.5138L313.2 92.7138L316.3 95.8138Z",
  fill: "#22272E"
});

var _ref204 = /*#__PURE__*/React.createElement("path", {
  d: "M631.4 229.414L539.2 218.614C536.5 218.314 534.9 215.914 535.5 213.214L556.8 115.814C557.3 113.514 559.5 111.614 561.9 111.314L658.1 101.214C660.6 100.914 662.5 102.914 662 105.314L636.5 225.714C635.9 228.014 633.7 229.714 631.4 229.414Z",
  fill: "#63737A"
});

var _ref205 = /*#__PURE__*/React.createElement("path", {
  d: "M627.7 229.414L534.7 218.514C532 218.214 530.3 215.814 530.9 213.114L552.4 115.014C552.9 112.614 555.1 110.714 557.6 110.514L654.5 100.314C657 100.014 658.9 102.014 658.4 104.414L632.6 225.814C632.2 228.014 629.9 229.714 627.7 229.414Z",
  fill: "#22272E"
});

var _ref206 = /*#__PURE__*/React.createElement("path", {
  d: "M593.4 135.314L558.4 137.014C557.5 137.014 556.8 136.314 557 135.414L559.8 122.414C560 121.714 560.6 121.114 561.4 121.014L596.7 118.014C597.7 117.914 598.3 118.714 598.1 119.614L595 134.014C594.9 134.614 594.2 135.214 593.4 135.314Z",
  fill: "#F6AE2D"
});

var _ref207 = /*#__PURE__*/React.createElement("path", {
  d: "M547.1 208.214C546.3 208.114 545.8 207.414 546 206.714L551.2 182.314C551.4 181.514 552.1 180.914 552.9 181.014C553.7 181.114 554.2 181.714 554 182.514L548.8 207.014C548.7 207.714 547.9 208.314 547.1 208.214Z",
  fill: "#F7D4D9"
});

var _ref208 = /*#__PURE__*/React.createElement("path", {
  d: "M559.5 207.914L565.7 179.114C565.9 178.314 566.6 177.714 567.4 177.814H567.6C568.4 177.814 568.9 178.514 568.8 179.314L562.6 208.114C562.4 208.914 561.6 209.514 560.8 209.414H560.6C559.8 209.414 559.3 208.714 559.5 207.914Z",
  fill: "#1D62D1"
});

var _ref209 = /*#__PURE__*/React.createElement("path", {
  d: "M573 209.014L580 176.114C580.2 175.214 581 174.614 581.9 174.614C582.8 174.614 583.4 175.414 583.2 176.314L576.2 209.214C576 210.114 575.1 210.714 574.2 210.714C573.4 210.714 572.8 209.914 573 209.014Z",
  fill: "#F6AE2D"
});

var _ref210 = /*#__PURE__*/React.createElement("path", {
  d: "M623 146.914L625.3 151.814C622.5 155.014 619.1 157.014 615.9 157.014C609.7 157.014 606.4 149.514 608.4 140.214C610.4 130.914 617 123.014 623.3 122.514C626.6 122.214 629.1 123.914 630.6 126.914L626.2 132.114C625.3 130.314 623.8 129.214 621.9 129.414C618.1 129.714 614.1 134.414 612.8 140.114C611.6 145.714 613.6 150.314 617.4 150.214C619.4 150.014 621.4 148.814 623 146.914Z",
  fill: "#F6AE2D"
});

var _ref211 = /*#__PURE__*/React.createElement("path", {
  d: "M631.6 139.114C630.5 144.014 628.2 148.514 625.4 151.714L623.1 146.814C624.8 144.914 626.2 142.214 626.8 139.314C627.4 136.414 627.2 133.814 626.3 132.014L630.7 126.814C632.2 129.914 632.6 134.214 631.6 139.114Z",
  fill: "#1D62D1"
});

var _ref212 = /*#__PURE__*/React.createElement("path", {
  d: "M596.3 195.414C594.3 204.714 597.6 212.214 603.8 212.214C607 212.214 610.4 210.214 613.2 207.014L610.9 202.114C609.2 204.014 607.2 205.214 605.3 205.314C601.5 205.414 599.5 200.814 600.7 195.214C601.2 192.714 602.4 190.314 603.8 188.514L601.7 183.914C599.2 187.114 597.2 191.114 596.3 195.414Z",
  fill: "#F6AE2D"
});

var _ref213 = /*#__PURE__*/React.createElement("path", {
  d: "M609.8 184.614C611.7 184.514 613.3 185.514 614.1 187.314L618.5 182.114C617 179.114 614.4 177.414 611.2 177.714C607.8 178.014 604.4 180.414 601.6 183.914L603.7 188.514C605.5 186.314 607.6 184.714 609.8 184.614Z",
  fill: "#1D62D1"
});

var _ref214 = /*#__PURE__*/React.createElement("path", {
  d: "M619.4 194.514C618.3 199.414 616 203.914 613.2 207.114L610.9 202.214C612.6 200.314 614 197.614 614.6 194.714C615.2 191.814 615 189.214 614.1 187.414L618.5 182.214C620 185.214 620.5 189.614 619.4 194.514Z",
  fill: "#F7D4D9"
});

var _ref215 = /*#__PURE__*/React.createElement("path", {
  d: "M555.8 145.714L580.4 144.814",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref216 = /*#__PURE__*/React.createElement("path", {
  d: "M554.4 151.314L589.6 150.914",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref217 = /*#__PURE__*/React.createElement("path", {
  d: "M553.3 157.114H588.9",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref218 = /*#__PURE__*/React.createElement("path", {
  d: "M645.3 110.014C645.5 109.214 645.2 108.614 644.6 108.614C644 108.714 643.4 109.414 643.3 110.214C643.1 111.014 643.4 111.614 644 111.614C644.6 111.514 645.2 110.814 645.3 110.014Z",
  fill: "#63737A"
});

var _ref219 = /*#__PURE__*/React.createElement("path", {
  d: "M651.1 109.514C651.3 108.714 650.9 108.114 650.4 108.114C649.8 108.214 649.2 108.914 649 109.714C648.8 110.514 649.2 111.114 649.7 111.114C650.4 111.014 651 110.314 651.1 109.514Z",
  fill: "#63737A"
});

var _ref220 = /*#__PURE__*/React.createElement("path", {
  d: "M280.9 331.014V331.314C280.9 332.314 280.1 333.114 279.1 333.114H194.3C193.3 333.114 192.5 332.314 192.5 331.314C192.5 330.714 192.8 330.114 193.2 329.614L209.6 313.414C210.4 312.614 211.4 312.214 212.4 312.214H268.1C269.5 312.214 270.9 313.014 271.6 314.214L280.6 329.714C280.7 330.214 280.9 330.614 280.9 331.014Z",
  fill: "#22272E"
});

var _ref221 = /*#__PURE__*/React.createElement("path", {
  d: "M238.6 326.714C238.6 327.014 238 327.314 237.2 327.314C236.4 327.314 235.8 327.014 235.8 326.714C235.8 326.414 236.4 326.114 237.2 326.114C238 326.114 238.6 326.414 238.6 326.714Z",
  fill: "#63737A"
});

var _ref222 = /*#__PURE__*/React.createElement("path", {
  d: "M575.7 419.914C575.7 419.914 568 403.414 587.3 393.014C606.6 382.614 633.4 392.914 631 396.514C629.5 398.714 625.6 405.114 618.3 413.014C612.2 419.714 594.7 430.114 575.7 419.914Z",
  fill: "#F6AE2D"
});

var _ref223 = /*#__PURE__*/React.createElement("path", {
  d: "M627.6 395.814C627.6 395.814 585.2 386.314 575.6 419.914C566.1 453.514 569 485.714 569 485.714",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref224 = /*#__PURE__*/React.createElement("path", {
  d: "M537.5 457.714L544.4 539.014C544.4 542.114 557 544.514 572.6 544.514C588.1 544.514 600.8 542.014 600.8 539.014L607.7 457.714H537.5Z",
  fill: "#22272E"
});

var _ref225 = /*#__PURE__*/React.createElement("path", {
  d: "M572.6 463.014C591.93 463.014 607.6 460.641 607.6 457.714C607.6 454.787 591.93 452.414 572.6 452.414C553.27 452.414 537.6 454.787 537.6 457.714C537.6 460.641 553.27 463.014 572.6 463.014Z",
  fill: "#F6AE2D"
});

var _ref226 = /*#__PURE__*/React.createElement("path", {
  d: "M563.7 440.814C563.7 440.814 552.4 435.214 545.1 447.814C537.8 460.514 543.2 479.414 548.2 482.214C553.2 485.014 574 475.514 574 456.414C574 439.414 563.7 440.814 563.7 440.814Z",
  fill: "#F6AE2D"
});

var _ref227 = /*#__PURE__*/React.createElement("path", {
  d: "M563.7 440.814C563.7 440.814 552.4 440.014 549 479.614",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref228 = /*#__PURE__*/React.createElement("path", {
  d: "M555.1 417.714C555.1 417.714 543.2 399.214 519.4 411.114C495.6 423.014 496.3 455.814 500 457.714C503.8 459.614 559.4 440.214 555.1 417.714Z",
  fill: "#F6AE2D"
});

var _ref229 = /*#__PURE__*/React.createElement("path", {
  d: "M574 456.414C574 456.414 566.6 430.414 555.1 417.614C543.5 404.814 507.9 419.514 501.6 450.414",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref230 = /*#__PURE__*/React.createElement("path", {
  d: "M587.3 428.114C587.3 428.114 577.2 424.614 572.6 437.114C568.1 449.314 573.4 477.114 599.4 485.514C600.8 485.914 602.3 485.514 603.2 484.414C606.4 480.714 613.1 471.014 613.1 456.414C613 436.114 601.8 421.414 587.3 428.114Z",
  fill: "#F6AE2D"
});

var _ref231 = /*#__PURE__*/React.createElement("path", {
  d: "M587.3 428.114C587.3 428.114 608.3 438.414 600.6 481.714",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref232 = /*#__PURE__*/React.createElement("path", {
  d: "M374.6 294.314C374.6 294.314 375 306.914 393.2 308.114C411.3 309.414 446.6 305.314 453.5 303.414C460.4 301.514 460 290.414 455.6 287.314C451.2 284.214 424.8 282.814 411.3 280.814C408.2 280.314 404.6 279.714 400.9 279.414C397.7 279.114 394.5 278.914 391.4 279.014C382.3 279.414 374.7 282.914 374.6 294.314Z",
  fill: "#F6AE2D"
});

var _ref233 = /*#__PURE__*/React.createElement("path", {
  d: "M374.4 290.814C374.4 290.814 374.4 288.214 378.3 288.914C386.8 290.514 394 308.814 385.3 306.514",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref234 = /*#__PURE__*/React.createElement("path", {
  d: "M411.2 280.814C408.1 280.314 404.5 279.714 400.8 279.414C397.6 279.114 394.4 278.914 391.3 279.014",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref235 = /*#__PURE__*/React.createElement("path", {
  d: "M500.5 222.414C503.8 223.514 506.2 226.114 510.4 238.814C515.9 255.414 522.9 290.614 519.3 300.114C515.7 309.614 508.5 314.514 484.3 315.614C460.1 316.714 436.6 314.814 433.5 314.814C430.4 314.814 425.2 303.414 428.5 295.914C428.5 295.914 449 290.914 460.6 287.814C472.2 284.714 485 281.414 490.3 280.814C490.3 280.814 481.7 259.714 478.9 252.314C476.1 244.914 478.4 232.314 485 226.614C491.5 221.014 497.7 221.514 500.5 222.414Z",
  fill: "#F6AE2D"
});

var _ref236 = /*#__PURE__*/React.createElement("path", {
  d: "M490.2 280.814C490.2 280.814 500.1 278.814 506 280.814",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref237 = /*#__PURE__*/React.createElement("path", {
  d: "M520.3 294.314C520.3 294.314 518.2 289.314 509.7 294.914C503 299.314 501 312.514 508.3 311.714",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref238 = /*#__PURE__*/React.createElement("path", {
  d: "M430.5 296.114C430.5 296.114 425.2 296.614 419.8 296.614C414.4 296.614 407.1 297.514 405.4 298.314C403.7 299.014 386.5 316.314 386.9 318.614C387.2 320.914 390.5 319.414 393.3 317.514C396 315.514 401.3 310.414 402.4 309.714C402.4 309.714 401 312.914 399.7 317.714C398.4 322.514 397.1 327.314 398.4 328.114C400.1 329.114 401.7 327.414 402.2 326.414C402.2 326.414 402.1 328.914 404.1 329.014C406.1 329.114 408 325.314 409.6 322.114C411.3 318.914 414.7 314.714 414.7 314.714C414.7 314.714 413.1 319.814 412.5 322.614C411.9 325.414 411.5 328.714 413 329.014C415.3 329.514 417.4 322.714 418.7 320.114C420.1 317.414 425.1 319.214 428.8 316.914C432.6 314.514 434.6 313.914 434.6 313.914C434.6 313.914 437.1 311.414 437.1 306.014C437.1 300.514 432.6 295.914 430.5 296.114Z",
  fill: "#F7D4D9"
});

var _ref239 = /*#__PURE__*/React.createElement("path", {
  d: "M402 326.514C402 326.514 406.8 312.514 408.8 309.814C410.8 307.114 411.5 306.914 412.1 306.514",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref240 = /*#__PURE__*/React.createElement("path", {
  d: "M402.2 309.814C402.2 309.814 403 308.214 404.3 305.814C405 304.614 406.5 303.414 406.5 303.414",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref241 = /*#__PURE__*/React.createElement("path", {
  d: "M414.5 314.714C414.5 314.714 415.9 311.314 417.3 310.914",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref242 = /*#__PURE__*/React.createElement("path", {
  d: "M446.4 285.914C446.4 285.914 450.4 284.614 454.1 282.914C457.8 281.214 459.3 280.514 462.2 280.314C465.1 280.014 474.2 280.014 475.5 280.814C476.8 281.614 478.5 285.414 479.4 287.314C480.3 289.214 477.4 296.714 477.4 296.714C477.4 296.714 478.7 303.314 477.1 304.014C476.1 304.414 475.2 304.214 473.9 300.714C473.9 300.714 474.8 303.714 473 303.914C471.2 304.114 469.2 298.914 467.9 296.614C466.6 294.314 464.1 291.414 464.1 291.414C464.1 291.414 465.2 295.014 465.4 296.214C465.6 297.514 466.4 300.514 465.9 301.714C465.4 302.914 463.6 301.314 461.8 297.214C460 293.114 459.4 291.714 458.3 291.814C452.1 292.414 452.5 291.014 449.5 290.814L442.9 292.514C442.8 292.414 442.1 288.414 446.4 285.914Z",
  fill: "#F7D4D9"
});

var _ref243 = /*#__PURE__*/React.createElement("path", {
  d: "M473.9 300.614C473.9 300.614 471.9 294.114 471.2 292.114C470.5 290.214 468.2 286.614 468.2 286.614",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref244 = /*#__PURE__*/React.createElement("path", {
  d: "M477.4 296.614C477.4 296.614 476.2 289.614 475.7 287.914C475.2 286.314 474.4 284.814 474.4 284.814",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref245 = /*#__PURE__*/React.createElement("path", {
  d: "M464 291.314C464 291.314 463.4 289.314 463.1 288.714",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgSignIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 696,
    height: 552,
    viewBox: "0 0 696 552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_301_3057",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 83,
    width: 676,
    height: 368
  }, _ref3), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/SignIn.c45ef11c.svg";
export { ForwardRef as ReactComponent };